import { apiRequest } from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { setSnack } from 'utilities/redux.actions';

export default function* (action) {
    const {
        meta: { handleComplete = () => {} },
        payload: { email, roleName, action: roleAction },
    } = action;

    try {
        const { data } = yield call(apiRequest, {
            url: 'user/manage-role',
            method: 'post',
            data: JSON.stringify({ email, roleName, action: roleAction }),
        });

        yield put(
            setSnack({
                message: roleAction === 'add'
                    ? `Role "${roleName}" added successfully`
                    : `Role "${roleName}" removed successfully`,
                type: 'success',
            })
        );

        return handleComplete(null, data);
    } catch (error) {
        yield put(
            setSnack({
                message: error?.response?.data?.message || error?.message || 'Failed to update role',
                type: 'error',
            })
        );
        return handleComplete(error);
    }
}
